var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-text-info-line"},[_c('div',{staticClass:"wp-text-info-line__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"wp-text-info-line__value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }